import React, { useEffect, useState } from 'react';
import * as PR from "../../../../prime-react/index";
import "./BetList.scss";
import { currencyFormat, dateTimeFormat, numberFormat } from '../../../../utils/reuse';
import BetTable from './BetTable';

const BetList = ({ betList, loading, page, paging, last, handlePageChange, onTabChange, sortHandler, sortField, sortOrder, type, groupId }) => {
  const [betData, setBetData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);


  const tabsMenu = [
    {label: 'All', value: ''},
    {label: 'Singles', value: 'single'},
    {label: 'Parlays', value: 'parlay'}
  ];
  
  useEffect(() => {
    const formattedData = betList.map(bet => {
     const betEvent = bet.events?.length ? bet.events.map(e => e.event).join('; ') : '';
     const betSport = bet.events?.length ? bet.events.map(e => e.sport).join('; ') : '';
     const betMarket = bet.events?.length ? bet.events.map(e => e?.market).join('; ') : '';
      return {
      ...bet,
     // property: 'Online',
       event: betEvent?.length > 50 ? betEvent.slice(0, 50) + '...' : betEvent ,
      sport: betSport?.length > 50 ? betSport.slice(0, 30) + '...' : betSport , 
      market: betMarket?.length > 50 ? betMarket.slice(0, 50) + '...' : betMarket,
      eventDateFormat: dateTimeFormat(bet.eventDate),
      soldFormat: numberFormat(bet.sold),
      stakeFormat: currencyFormat(bet.stake, groupId),
      netGGRFormat: currencyFormat(bet.netGGR, groupId),
    }});
  
    setBetData(formattedData);
  }, [betList, activeIndex, groupId]);

  const handleTabSwitch = (e) => {
    setActiveIndex(e.index);
    const reportType = tabsMenu[e.index].value;
    onTabChange?.(reportType); // Notify parent (Dashboard)
  };

  return (
    <>
      <section className={`best-list-section ${type === 'player' ? 'player-betting-tabs': type === 'anomalies' ? 'anomalies-section' : ''}`}>
        {type !== 'anomalies' &&
          <div className="flex align-items-center justify-content-between">
            <h2 className='heading-h2'>{type ? 'Betting history' : 'Bet List'}</h2>
          </div>
        }
        <PR.TabView className="stats-tab-section" activeIndex={activeIndex} onTabChange={handleTabSwitch}>
          {
            tabsMenu.map((menu, index) => (
              <PR.TabPanel key={index} header={menu.label}>
                <BetTable betData={betData} loading={loading} page={page} paging={paging} last={last} sortField={sortField} sortOrder={sortOrder} handlePageChange={handlePageChange} sortHandler={sortHandler} type={type} groupId={groupId}></BetTable>
              </PR.TabPanel>
            ))
          }
        </PR.TabView>
      </section>
    </>
  );
};

export default BetList;
